import { createSlice } from "@reduxjs/toolkit";

const initialCommentsState = {
  commentsList: [],
  listLoading: false,
  error: null,
  hideLoading: false,
  commentHided: null,
};

export const callTypes = {
  list: "list",
  hide: "hide",
};

export const commentsSlice = createSlice({
  name: "Comments",
  initialState: initialCommentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.hide:
          state.hideLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.hide:
          state.hideLoading = true;
          break;
        default:
          break;
      }
    },
    commentsFetched: (state, action) => {
      state.commentsList = action.payload.commentsList;
      state.listLoading = false;
      state.error = null;
    },
    commentHided: (state, action) => {
      state.commentHided = action.payload.commentHided;
      state.hideLoading = false;
      state.error = null;
    },
  },
});
